/* ==========================================================================
   OptimOZ FAQ — accordion, live search, category filter
   File location in Shopify: assets/optimoz-faq.js
   Loaded conditionally from theme.liquid only on /pages/faq
   ========================================================================== */

(function () {
  'use strict';

  // Wait for DOM ready
  function init() {
    const items = document.querySelectorAll('.faq-item');
    const cats = document.querySelectorAll('.faq-category');
    const tabs = document.querySelectorAll('.cat-tab');
    const noResults = document.getElementById('no-results');
    const searchInput = document.getElementById('search-input');
    const searchClear = document.getElementById('search-clear');

    // Bail safely if FAQ markup isn't on this page
    if (!items.length || !searchInput) return;

    let activeCat = 'all';

    // Hide the clear button initially (in case CSS doesn't load it hidden)
    if (searchClear) searchClear.classList.remove('visible');

    // ── Accordion ──
    items.forEach(function (item) {
      const btn = item.querySelector('.faq-q');
      if (!btn) return;
      btn.addEventListener('click', function () {
        const isOpen = item.classList.contains('open');
        items.forEach(function (i) { i.classList.remove('open'); });
        if (!isOpen) item.classList.add('open');
      });
    });

    // ── Category filter ──
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activeCat = tab.dataset.cat;
        tabs.forEach(function (t) { t.classList.remove('active'); });
        tab.classList.add('active');
        searchInput.value = '';
        if (searchClear) searchClear.classList.remove('visible');
        applyFilters();
      });
    });

    // ── Search ──
    searchInput.addEventListener('input', function () {
      const q = searchInput.value.trim();
      if (searchClear) searchClear.classList.toggle('visible', q.length > 0);
      activeCat = 'all';
      tabs.forEach(function (t) { t.classList.remove('active'); });
      if (tabs[0]) tabs[0].classList.add('active');
      applyFilters();
    });

    if (searchClear) {
      searchClear.addEventListener('click', function () {
        searchInput.value = '';
        searchClear.classList.remove('visible');
        applyFilters();
      });
    }

    // ── Filtering logic ──
    function applyFilters() {
      const q = searchInput.value.toLowerCase().trim();
      let visibleCount = 0;

      cats.forEach(function (cat) {
        let catVisible = false;

        cat.querySelectorAll('.faq-item').forEach(function (item) {
          const qEl = item.querySelector('.faq-q');
          const aEl = item.querySelector('.faq-a-inner');
          if (!qEl || !aEl) return;
          const qText = qEl.textContent.toLowerCase();
          const aText = aEl.textContent.toLowerCase();
          const catMatch = activeCat === 'all' || item.dataset.cat === activeCat;
          const searchMatch = !q || qText.includes(q) || aText.includes(q);

          if (catMatch && searchMatch) {
            item.classList.remove('hidden');
            catVisible = true;
            visibleCount++;
          } else {
            item.classList.add('hidden');
            item.classList.remove('open');
          }
        });

        cat.classList.toggle('hidden', !catVisible);
      });

      if (noResults) {
        noResults.classList.toggle('visible', visibleCount === 0);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
